export default __webpack_public_path__ + "static/media/time-line-active-moblie.ba843bd2.svg";